import { makeServiceHeaders } from "@coworker/app/src/core/hooks/fetch.helpers";
import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";
import { getTokenAsync } from "@coworker/app/src/hooks/API/getAuthToken";

async function deleteTeam(teamId: string) {
  const token = await getTokenAsync();
  const headers = await makeServiceHeaders();
  const url = `${CORE_SERVICE_URL}/teams/${teamId}`;

  if (!token || typeof token !== "string") {
    console.error("No valid auth token found");
  }

  const result = await fetch(url, {
    method: "DELETE",
    headers,
    body: JSON.stringify({}),
  });

  if (!result.ok) {
    const errorDetails = await result.text();
    console.error(
      `Failed to delete team: ${result.status} ${result.statusText}. Details: ${errorDetails}`
    );
  }

  return result;
}

export default deleteTeam;
